import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { Layers } from "lucide-react";

export const Route = createFileRoute("/_authenticated/collection")({
  head: () => ({ meta: [{ title: "Collection — Want To Buy" }] }),
  component: CollectionPage,
});

function CollectionPage() {
  return (
    <AppShell>
      <div className="mb-6">
        <h1 className="font-display text-3xl font-bold flex items-center gap-2">
          <Layers className="h-7 w-7 text-primary" /> Collection
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Upload your cards. Set each item to Private, Public, or Subject to Offers — and pin up to 3 to your profile showcase.
        </p>
      </div>
      <div className="panel grid place-items-center p-16 text-center">
        <Layers className="mb-4 h-10 w-10 text-muted-foreground" />
        <h2 className="font-display text-xl font-bold">Collection coming in the next phase</h2>
        <p className="mt-2 max-w-md text-sm text-muted-foreground">
          Upload form, visibility states (Private / Public / Subject to Offers), and the profile banner showcase land in phase 2.
        </p>
      </div>
    </AppShell>
  );
}
